import CustomerContactChannelsFilter from "./CustomerContactChannelsFilter";
import CustomerInformationFilter from "./CustomerInformationFilter";
import CustomerValueAnalysisFilter from "./CustomerValueAnalysisFilter";
import NextBestActivityFilter from "./NextBestActivityFilter";

export {
  CustomerContactChannelsFilter,
  CustomerInformationFilter,
  CustomerValueAnalysisFilter,
  NextBestActivityFilter,
};



// WEBPACK FOOTER //
// ./src/components/Filters/index.tsx